import React from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  useTheme,
  useMediaQuery,
  alpha,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';

/**
 * Call-to-action block — publish your listing.
 * Sober, visible, min 48px button height on mobile.
 */
const CTASection = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleCTA = () => {
    if (user) {
      navigate('/dashboard/create-listing');
    } else {
      navigate('/register');
    }
  };

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 5, md: 7 },
        background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
      }}
    >
      <Container maxWidth="sm" sx={{ textAlign: 'center' }}>
        <Typography
          variant={isMobile ? 'h6' : 'h5'}
          component="h2"
          sx={{ color: '#fff', fontWeight: 700, mb: 1.5 }}
        >
          {t('homepage.cta.title')}
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: alpha('#fff', 0.85),
            mb: 3,
            maxWidth: 440,
            mx: 'auto',
          }}
        >
          {t('homepage.cta.subtitle')}
        </Typography>

        <Button
          variant="contained"
          size="large"
          onClick={handleCTA}
          sx={{
            bgcolor: '#fff',
            color: theme.palette.primary.main,
            fontWeight: 700,
            fontSize: { xs: '0.9rem', md: '1rem' },
            height: { xs: 48, md: 52 },
            px: 4,
            borderRadius: 2,
            textTransform: 'none',
            '&:hover': {
              bgcolor: alpha('#fff', 0.9),
            },
          }}
        >
          {user
            ? t('homepage.cta.publish')
            : t('homepage.cta.register')}
        </Button>
      </Container>
    </Box>
  );
};

export default CTASection;
